export default {
  namespaced: true,
  state: {
    returnFromContent:false,
    returnFromList:false,
    returnFromStore:false,
    workflow:{
      name : '',
      disable_at: '',
      folder_id: undefined,
      active : false,
      retrigger : false,
      endAtTime : '',
      endAt : ''
    },
    template: {},
    journeyTitle: null,
    listPresent: false,
    contentPresent: false,
    storePresent: false
  },
  mutations: {
    returnFromContent: (state, value) => {
      state.returnFromContent = value;
    },
    returnFromList: (state, value) => {
      state.returnFromList = value;
    },
    returnFromStore: (state, value) => {
      state.returnFromStore = value;
    },
    workflow: (state, value) =>{
      state.workflow = value;
    },
    template: (state, value) => {
      state.template = value;
    },
    journeyTitle: (state, value) => {
      state.journeyTitle = value;
    },
    listPresent: (state, value) => {
      state.listPresent = value;
    },
    contentPresent: (state, value) => {
      state.contentPresent = value;
    },
    storePresent: (state, value) => {
      state.storePresent = value;
    }
  },
  getters: {
    returnFromContent: state => state.returnFromContent,
    returnFromList: state => state.returnFromList,
    returnFromStore: state => state.returnFromStore,
    workflow: state => state.workflow,
    template: state => state.template,
    journeyTitle: state => state.journeyTitle,
    listPresent: state => state.listPresent,
    contentPresent: state => state.contentPresent,
    storePresent: state => state.storePresent
  }
}